import { render, staticRenderFns } from "./UkHousingActSectionEight.vue?vue&type=template&id=a7f4f964&scoped=true&"
import script from "./UkHousingActSectionEight.vue?vue&type=script&lang=js&"
export * from "./UkHousingActSectionEight.vue?vue&type=script&lang=js&"
import style0 from "./UkHousingActSectionEight.vue?vue&type=style&index=0&id=a7f4f964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f4f964",
  null
  
)

export default component.exports